import { render, staticRenderFns } from "./Sizes.vue?vue&type=template&id=599b86a0&scoped=true"
import script from "./Sizes.vue?vue&type=script&lang=js"
export * from "./Sizes.vue?vue&type=script&lang=js"
import style0 from "./Sizes.vue?vue&type=style&index=0&id=599b86a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599b86a0",
  null
  
)

export default component.exports